export enum ReportTypeEnum {
    PERFORMANCE = 'Performance', // Hiệu suất
    REPEAT_ERROR = 'RepeatError', // Lỗi lặp lại
    ERROR_FREQUENCY = 'ErrorFrequency', // Tần suất lỗi
}
